<template>
    <validation-observer ref="form" v-slot="{ meta, handleSubmit, errors, setFieldValue }">
        <modal
            :id="modalId"
            title="Settings"
            ok-title="Save"
            :ok-disabled="!meta.valid || loading"
            @ok.prevent="handleSubmit(_, save)"
            @hide="hideModal"
            @hidden="hiddenModal"
            @shown="setData"
        >
            <busy-modal :show="loading"></busy-modal>
            <b-form @submit.prevent="handleSubmit(_, save)" v-if="values">
                <b-row>
                    <b-col>
                        <label>Commission:</label>
                        <validation-provider name="commission" rules="required|validFloat">
                            <form-input
                                v-model="values.commission"
                                :rightIcon="['fas', 'percent']"
                                :error="errors.commission"
                                @input="(val) => setFieldValue('commission', val)"
                            />
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <validation-provider name="rate_rules_export_period" rules="required">
                            <form-select
                                label="Rate/Rules Export Period:"
                                v-model="values.rate_rules_export_period"
                                :options="rateRulesExportPeriodOptions"
                                :error="errors.rate_rules_export_period"
                                @change="(val) => setFieldValue('rate_rules_export_period', val)"
                            ></form-select>
                        </validation-provider>
                    </b-col>
                </b-row>
            </b-form>
        </modal>
    </validation-observer>
</template>

<script>
    import isEmpty from 'lodash/isEmpty';
    import API from '../../../api';
    import { PARTNER_NEXTPAX_SETTINGS_ENDPOINT } from '../../../endpoints';
    import { formatResponseError } from '../../../utils/api';
    import BusyModal from '../../generic/busy-modal/busy-modal.vue';
    import FormInput from '../../generic/form-input/form-input.vue';
    import FormSelect from '../../generic/form-select/form-select.vue';
    import Modal from '../../generic/modal/modal.vue';

    export default {
        name: 'NextpaxSettingsModalForm',
        components: {
            BusyModal,
            FormInput,
            FormSelect,
            Modal,
        },
        props: {
            modalId: String,
            activeChannel: String,
            partnerSettings: Object,
        },
        mounted() {
            this.values = this.getInitialValues();
        },
        data() {
            return {
                loading: false,
                values: null,
                rateRulesExportPeriodOptions: [
                    { value: 3, text: '3 Months' },
                    { value: 6, text: '6 Months' },
                    { value: 12, text: '1 Year' },
                    { value: 18, text: '18 Months' },
                ],
            };
        },
        methods: {
            getInitialValues() {
                return {
                    commission: this.partnerSettings.commission,
                    rate_rules_export_period: this.partnerSettings.rate_rules_export_period,
                };
            },
            hideModal() {
                this.$bvModal.hide(this.modalId);
            },
            hiddenModal() {
                this.$emit('hidden');
            },
            setData() {
                this.$refs.form.setValues({
                    rate_rules_export_period: this.values.rate_rules_export_period,
                    commission: this.values.commission,
                })
            },
            async save() {
                this.loading = true;

                try {
                    await API.patch(PARTNER_NEXTPAX_SETTINGS_ENDPOINT(this.activeChannel), this.values);
                    this.$emit('success-save');
                    this.$nextTick(() => {
                        this.hideModal();
                    });
                } catch (error) {
                    const { generic, fields } = formatResponseError(error);
                    if (generic) {
                        this.errorToast({ text: generic });
                    }
                    if (!isEmpty(fields)) {
                        this.$refs.form.setErrors(fields);
                    }
                } finally {
                    this.loading = false;
                }
            },
        },
        watch: {
            partnerSettings() {
                this.values = this.getInitialValues();
            },
        },
    };
</script>
